import { Method, getFileUrl, getFileName } from "../../config/s3publicfiles.config";
import WFIDButton from "../WFIDButton/WFIDButton";
import { isLoggedinUserAdminSelector } from '../../store/slices/appSlice'; 
import { useSelector } from 'react-redux';

const DownloadSampleData = () => {
  const isLoggedinUserAdmin = useSelector(isLoggedinUserAdminSelector);

  if (isLoggedinUserAdmin) {
    return (
      <div className="download-sample-data-btn-container">
        <WFIDButton
          bgColor="#FAFAFA"
          onClick={() => {}}
          content={
            <a
              className="download-sample-data-btn"
              download={getFileName(Method.SIRA)}
              href={getFileUrl(Method.SIRA)}
            >
              SIRA
            </a>
          }
        />
        <WFIDButton
          bgColor="#FAFAFA"
          onClick={() => {}}
          content={
            <a
              className="download-sample-data-btn"
              download={getFileName(Method.XRF)}
              href={getFileUrl(Method.XRF)}
            >
              XRF
            </a>
          }
        />
        <WFIDButton
          bgColor="#FAFAFA"
          onClick={() => {}}
          content={
            <a
              className="download-sample-data-btn"
              download={getFileName(Method.ICPMS)}
              href={getFileUrl(Method.ICPMS)}
            >
              ICPMS
            </a>
          }
        />
        <WFIDButton
          bgColor="#FAFAFA"
          onClick={() => {}}
          content={
            <a
              className="download-sample-data-btn"
              download={getFileName(Method.SIRAXRF)}
              href={getFileUrl(Method.SIRAXRF)}
            >
              SIRA & XRF
            </a>
          }
        />
      </div>
    );
  } else {
    return (
      <div className="download-sample-data-btn-container">
        <WFIDButton
          bgColor="#FAFAFA"
          onClick={() => {}}
          content={
            <a
              className="download-sample-data-btn"
              download={getFileName(Method.SIRA)}
              href={getFileUrl(Method.SIRA)}
            >
              SIRA Template
            </a>
          }
        />
        <WFIDButton
          bgColor="#FAFAFA"
          onClick={() => {}}
          content={
            <a
              className="download-sample-data-btn"
              download={getFileName(Method.SIRAXRF)}
              href={getFileUrl(Method.SIRAXRF)}
            >
              SIRA & XRF Template
            </a>
          }
        />
      </div>
    );
  }
};
export default DownloadSampleData;
